import React from 'react'
import { Button, Header, Icon, Divider } from 'semantic-ui-react'
import history from 'services/history'

export default function Menu({ path }) {
    return (
        <div className="row flex-grow-1 mt-2">
            <div className="col d-flex flex-column">
                <div className="row mx-0">
                    <div className="col">
                        <Header as='h3'>
                        <Icon.Group size='big'>
                                <Icon name='group' className='primary-color' />
                            </Icon.Group>
                            <Header.Content className='primary-color'>
                                Departamento Pessoal <Header.Subheader className='secondary-color'>Menu</Header.Subheader>
                            </Header.Content>
                        </Header>
                    </div>
                </div>

                <Divider className='mt-2 custom-divider darken' fitted />

                <div className="row flex-grow-1 flex-column">
                    <div className="col d-flex align-items-center flex-column justify-content-center">
                        <Button icon style={{ maxWidth: 300 }} className='w-50 btn-primary mt-2' onClick={() => history.push(`${path}/digitar-eventos`)} color='blue' size='small' fluid>
                            <Icon name='keyboard' /> Digitar eventos
                        </Button>
                        <Button icon style={{ maxWidth: 300 }} className='w-50 btn-primary mt-2' onClick={() => history.push(`${path}/listar-digitacoes`)} color='blue' size='small' fluid>
                            <Icon name='list alternate' /> Listar Digitações
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    )
}
